import { render, staticRenderFns } from "./dynamicTable.vue?vue&type=template&id=796c7416&scoped=true&"
import script from "./dynamicTable.vue?vue&type=script&lang=js&"
export * from "./dynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c7416",
  null
  
)

export default component.exports